import React, { useEffect } from "react";
import "./Toast.scss";

export default function Toast({ id, message, type, duration, isClosing, onClose }) {
  // auto-close
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`toast ${type} ${isClosing ? "closing" : ""}`}>
      <span className="icon">{getIcon(type)}</span>
      <span className="message-text">{message}</span>
      <button className="close-btn" onClick={onClose}>×</button>
    </div>
  );
}

function getIcon(type) {
  switch (type) {
    case "info": return "ℹ️";
    case "alert": return "⚠️";
    case "delete": return "🗑️";
    case "error": return "❌";
    case "success": return "✔️";
    default: return "ℹ️";
  }
}
